import {Component, Input, ViewChild} from '@angular/core';
import {BaseResultComponent} from '../base-result/base-result.component';
import {WelfareResultService} from '../../../service/welfare-result.service';
import {BoardViewComponent} from './project-view/board-view/board-view.component';
import {LifeProjectResult} from '../../../class/result/life-project-result';
import {NbWindowService} from '@nebular/theme';

@Component({
  selector: 'app-life-project-result',
  templateUrl: './life-project-result.component.html',
  styleUrls: ['./life-project-result.component.css']
})
export class LifeProjectResultComponent extends BaseResultComponent {

  @ViewChild('boardViewComponent')
  boardViewComponent: BoardViewComponent;

  @Input()
  lifeProjectResult: LifeProjectResult;

  constructor(private welfareService: WelfareResultService, windowService: NbWindowService) {
    super(windowService);
  }

  onResultImpl() {
    if (this.boardViewComponent) {
      this.boardViewComponent.onResultImpl();
    }
  }
}
